export default [
    {
        path: '/pages/user/shopVipUser',
        name: '/pages/user/shopVipUser',
        meta: { title: '会员信息' },
        component: () => import('@/views/user/shopVipUser.vue')
    },
    {
        path: '/pages/user/vipDetail',
        name: '/pages/user/vipDetail',
        component: () => import('@/views/user/vipDetail.vue')
    },
    {
        path: '/pages/user/adminShopVip',
        name: '/pages/user/adminShopVip',
        meta: { title: '店铺会员' },
        component: () => import('@/views/user/adminShopVip.vue')
    },
    {
        path: '/pages/user/mallUser',
        name: '/pages/user/mallUser',
        meta: { title: '商城用户' },
        component: () => import('@/views/user/mallUser.vue')
    },
    {
        path: '/pages/user/mallUserDetail',
        name: '/pages/user/mallUserDetail',
        component: () => import('@/views/user/mallUserDetail.vue')
    },
    {
        path: '/pages/user/shopVipLevel',
        name: '/pages/user/shopVipLevel',
        meta: { title: '会员等级' },
        component: () => import('@/views/user/shopVipLevel.vue')
    },
    {
        path: '/views/sign/signRule',
        name: '/views/sign/signRule',
        meta: { title: '签到规则' },
        component: () => import('@/views/sign/signRule.vue')
    },
    {
        path: '/views/sign/signAccount',
        name: '/views/sign/signAccount',
        meta: { title: '签到账户' },
        component: () => import('@/views/sign/signAccount.vue')
    },
    {
        path: '/views/sign/signRecord',
        name: '/views/sign/signRecord',
        meta: { title: '签到记录' },
        component: () => import('@/views/sign/signRecord.vue')
    }
] 